import { PERMISSIONS } from "@procuremate/shared";
import { createBrowserRouter, Navigate } from "react-router";
import { AppShell } from "@/components/layout/app-shell";
import { AdminLayout } from "@/features/admin/admin-layout";
import { DirectoryPage } from "@/features/admin/directory-page";
import { ImportRunPage } from "@/features/admin/import-run-page";
import { ImportsPage } from "@/features/admin/imports-page";
import { InviteUserPage } from "@/features/admin/invite-user-page";
import { OrgPage } from "@/features/admin/org-page";
import { SupplierQueuePage } from "@/features/admin/supplier-queue-page";
import { UsagePage } from "@/features/admin/usage-page";
import { UserDetailPage } from "@/features/admin/user-detail-page";
import { UsersPage } from "@/features/admin/users-page";
import { AcceptInvitePage } from "@/features/auth/accept-invite-page";
import { ForgotPasswordPage } from "@/features/auth/forgot-password-page";
import { LoginPage } from "@/features/auth/login-page";
import { ResetPasswordPage } from "@/features/auth/reset-password-page";
import { RequestPage } from "@/features/requests/request-page";
import { RequestsPage } from "@/features/requests/requests-page";
import { SubmitPage } from "@/features/requests/submit-page";
import { QueuePage } from "@/features/review/queue-page";
import { ReviewPage } from "@/features/review/review-page";
import { RequireAuth } from "./require-auth";
import { RequirePermission } from "./require-permission";

/** Route table. Signed-out pages first; everything under "/" requires a session. */
export const routes = [
  { path: "/login", element: <LoginPage /> },
  { path: "/accept-invite", element: <AcceptInvitePage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <RequestsPage /> },
      { path: "requests/:id", element: <RequestPage /> },
      { path: "requests/:id/submit", element: <SubmitPage /> },
      {
        path: "queue",
        element: (
          <RequirePermission permission={PERMISSIONS.REQUESTS_REVIEW}>
            <QueuePage />
          </RequirePermission>
        ),
      },
      {
        path: "queue/:id",
        element: (
          <RequirePermission permission={PERMISSIONS.REQUESTS_REVIEW}>
            <ReviewPage />
          </RequirePermission>
        ),
      },
      {
        path: "admin",
        element: (
          <RequirePermission permission={PERMISSIONS.USERS_READ}>
            <AdminLayout />
          </RequirePermission>
        ),
        children: [
          { index: true, element: <Navigate to="users" replace /> },
          { path: "users", element: <UsersPage /> },
          {
            path: "users/new",
            element: (
              <RequirePermission permission={PERMISSIONS.USERS_MANAGE}>
                <InviteUserPage />
              </RequirePermission>
            ),
          },
          { path: "users/:id", element: <UserDetailPage /> },
          { path: "org", element: <OrgPage /> },
          {
            path: "directory",
            element: (
              <RequirePermission permission={PERMISSIONS.IMPORTS_MANAGE}>
                <DirectoryPage />
              </RequirePermission>
            ),
          },
          {
            path: "imports",
            element: (
              <RequirePermission permission={PERMISSIONS.IMPORTS_MANAGE}>
                <ImportsPage />
              </RequirePermission>
            ),
          },
          {
            path: "imports/:id",
            element: (
              <RequirePermission permission={PERMISSIONS.IMPORTS_MANAGE}>
                <ImportRunPage />
              </RequirePermission>
            ),
          },
          {
            path: "suppliers",
            element: (
              <RequirePermission permission={PERMISSIONS.IMPORTS_MANAGE}>
                <SupplierQueuePage />
              </RequirePermission>
            ),
          },
          {
            path: "usage",
            element: (
              <RequirePermission permission={PERMISSIONS.USAGE_READ}>
                <UsagePage />
              </RequirePermission>
            ),
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
